module.exports = __webpack_public_path__ + "static/media/holly-winter.975253c4.jpg";